import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api/bwm',
  headers: { 'x-api-key': process.env.REACT_APP_API_KEY || '' },
});

const authHeader = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const getUsers = (token) =>
  api.get('/users', authHeader(token)).then((r) => r.data);

export const createUser = (token, payload) =>
  api.post('/users', payload, authHeader(token)).then((r) => r.data);

export const getUser = (token, id) =>
  api.get(`/users/${id}`, authHeader(token)).then((r) => r.data);

export const updateUser = (token, id, payload) =>
  api.put(`/users/${id}`, payload, authHeader(token)).then((r) => r.data);

export const deleteUser = (token, id) =>
  api.delete(`/users/${id}`, authHeader(token)).then((r) => r.data);
